import {
	GET_MANAGERS,
	ADD_MANAGER,
	DELETE_MANAGER,
	UPDATE_MANAGER,
	UPDATE_MANAGER_PASSWORD,
} from '../action/manager'

const REQUEST = '_REQUEST',
	SUCCESS = '_SUCCESS',
	FAILURE = '_FAILURE'

const defaultState = {
	managers: [],
	updating: null,
	errorMessage: null,
}

const managerReducer = (state = defaultState, action) => {
	switch (action.type) {
		case ADD_MANAGER + REQUEST:
		case DELETE_MANAGER + REQUEST:
		case UPDATE_MANAGER + REQUEST:
		case UPDATE_MANAGER_PASSWORD + REQUEST:
			return {
				...state,
				updating: true,
			}
		case GET_MANAGERS + SUCCESS:
			return {
				...state,
				managers: action.result.data,
			}
		case ADD_MANAGER + SUCCESS:
			return {
				...state,
				errorMessage: null,
				updating: false,
			}
		case ADD_MANAGER + FAILURE:
			return {
				...state,
				errorMessage: action.error.response.data.message,
				updating: false,
			}
		case DELETE_MANAGER + SUCCESS:
			return {
				...state,
				errorMessage: null,
				updating: false,
			}
		case DELETE_MANAGER + FAILURE:
			return {
				...state,
				errorMessage: action.error.response,
				updating: false,
			}
		case UPDATE_MANAGER + SUCCESS:
			return {
				...state,
				errorMessage: null,
				updating: false,
			}
		case UPDATE_MANAGER + FAILURE:
			return {
				...state,
				errorMessage: action.error.response,
				updating: false,
			}
		case UPDATE_MANAGER_PASSWORD + SUCCESS:
			return {
				...state,
				errorMessage: null,
				updating: false,
			}
		case UPDATE_MANAGER_PASSWORD + FAILURE:
			return {
				...state,
				errorMessage: action.error.response,
				updating: false,
			}
		default: {
			return state
		}
	}
}

export default managerReducer
